import React from "react";
import img from "../../assets/icons/info-circle.svg";
import { WrapperDelete } from "./style";
import Button from "../FormElement/Button";
import { useHideModal } from "../../hooks";

function DeleteModal({ onClick }) {
  const { hideModal } = useHideModal();
  return (
    <div>
      <WrapperDelete>
        <img src={img} alt="" />
        <div className="text">
          <h2>O‘chirishni tasdiqlaysizmi?</h2>
        </div>
        <div className="buttons">
          <Button
            text={"Rad etish"}
            onClick={() => hideModal()}
            background="#BBBDC6"
          />
          <Button text={"O‘chirish"} background="#E05C5C" onClick={onClick} />
        </div>
      </WrapperDelete>
    </div>
  );
}

export default DeleteModal;
